import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { SCALType } from "../../../interfaces/LicenseModel";
import Swal from "sweetalert2";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./view-scal360-activation-history.component.html'),
    styles:[require('./view-scal360-activation-history.component.css')],
    selector:'view-scal360-activation-history'
})
export class ViewScal360ActivationHistoryComponent{
    dialogTitle='View SCAL 360 Activation History'
    errorMessage='';
    Scal360ActivationHistory;
    SelectedCustomerLicenseDetail;
    SCALTypeEnum=SCALType
    scal360LicenseDisplayList;
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        public dialogRef:MdDialogRef<ViewScal360ActivationHistoryComponent>,
        public appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.getScal360ActivationHistory()
    }
    getScal360ActivationHistory(){
        this.isLoading=true;
        this.licenseService.viewScal360ActivationHistory(this.SelectedCustomerLicenseDetail.LicenseDetailId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.Scal360ActivationHistory=data.DataObject
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    deleteActivation(row){
        Swal.fire({
            title: "Delete Activated User",
            text: "Are you sure you want to delete this activated user?",
            showCancelButton:true,
            showCloseButton:true,
            showConfirmButton:true,
            confirmButtonColor:'#FFCA28',
            confirmButtonText:'Yes',
            cancelButtonText:'No'
        }).then((result)=>{
            if(result.isConfirmed){
                this.appLoader.open()
                let model={
                    LicenseDetailId:row.LicenseDetailId,
                    ActivationId:row.ActivationId,
                    UpdatedBy:Number(localStorage.getItem('userid'))
                }
                this.licenseService.deleteScal360ActivationKey(model).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.scal360LicenseDisplayList=data.DataObject
                        this.SelectedCustomerLicenseDetail.NoOfLicenseActivated--;
                        this.dialogRef.close(this.scal360LicenseDisplayList)
                    }
                    this.appLoader.close()
                })
            }
        })
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/view-scal360-activation-history/view-scal360-activation-history.component.ts